import React from "react";
import BannerSlide from "@/app/components/UI/BannerSlide";
import { BannerSectionProps } from "@/app/interface/components";
import { useRouter } from "next/router";
import classNames from "classnames";
import styles from "@/styles/desktop/Home/BannerSection.module.scss";

const BannerSection: React.FC<BannerSectionProps> = ({
  setIsConditionsModalOpen,
  setConditionsContent,
  setChatbotOpen,
  bannerImagesMobile,
  bannerImagesTablet,
  links,
  calls,
  className,
}) => {
  const router = useRouter();
  const hasMobile = Boolean(bannerImagesMobile?.length);
  const hasTablet = Boolean(bannerImagesTablet?.length);

  if (!hasMobile && !hasTablet) return null;

  return (
    <section className={classNames(styles.main, {
      [styles.noTopPadding]: router.pathname === '/TPHiace'
    }, className)}>
      {hasMobile && (
        <div className="min-[540px]:hidden">
          <BannerSlide
            banners={bannerImagesMobile!}
            links={links}
            calls={calls}
            setChatbotOpen={setChatbotOpen}
            width={430}
            height={504}
            setIsConditionsModalOpen={setIsConditionsModalOpen}
            setConditionsContent={setConditionsContent}
            className={router.pathname === '/TPHiace' ? 'no-padding-mobile' : ''}
          />
        </div>
      )}
      {hasTablet && (
        <div className="hidden min-[540px]:block">
          <BannerSlide
            banners={bannerImagesTablet!}
            links={links}
            calls={calls}
            setChatbotOpen={setChatbotOpen}
            width={1024}
            height={1204}
            setIsConditionsModalOpen={setIsConditionsModalOpen}
            setConditionsContent={setConditionsContent}
            className={router.pathname === '/TPHiace' ? 'no-padding-mobile' : ''}
          />
        </div>
      )}
    </section>
  );
};

export default React.memo(BannerSection);
